module.exports = __webpack_public_path__ + "static/media/playlist-stop-icon.e9d2da74.svg";